import API from '../dataApi';

export const getStates = () => API.get('/locations/states');
export const getCitiesByState = (stateId) => API.get('/locations/cities', { params: { stateId } });
